"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const paramsFormatter_1 = (0, tslib_1.__importDefault)(require("../paramsFormatter"));
const resultFormatter_1 = (0, tslib_1.__importDefault)(require("../resultFormatter"));
exports.default = {
    sendTransaction: {
        method: 'send_transaction',
        paramsFormatters: [paramsFormatter_1.default.toRawTransaction, paramsFormatter_1.default.toOutputsValidator],
        resultFormatters: resultFormatter_1.default.toHash,
    },
    txPoolInfo: {
        method: 'tx_pool_info',
        paramsFormatters: [],
        resultFormatters: resultFormatter_1.default.toTxPoolInfo,
    },
    clearTxPool: {
        method: 'clear_tx_pool',
        paramsFormatters: [],
    },
    getRawTxPool: {
        method: 'get_raw_tx_pool',
        paramsFormatters: [],
        resultFormatters: resultFormatter_1.default.toRawTxPool,
    },
};
//# sourceMappingURL=pool.js.map